var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.083,
    height: 41.656,
    viewBox: "0 0 168.083 41.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9800",
    "data-name": "Path 9800",
    d: "M37,105.837v.263l3.708,3.709.082-.048,4.393-2.5c1.255-.713,1.255-1.875,0-2.592l-4.392-2.5-.082-.047Z",
    transform: "translate(-37 -102.131)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9801",
    "data-name": "Path 9801",
    d: "M16.971,120.189a1.46,1.46,0,0,0,1.866.056l13.114-7.452L28.159,109Z",
    transform: "translate(-16.971 -109)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9802",
    "data-name": "Path 9802",
    d: "M16.971,88.69,28.159,99.878l3.793-3.792L18.837,88.632a2.062,2.062,0,0,0-1.005-.3,1.15,1.15,0,0,0-.859.356",
    transform: "translate(-16.971 -88.33)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57085",
    "data-name": "Group 57085",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57073",
    "data-name": "Group 57073",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57086",
    "data-name": "Group 57086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9797",
    "data-name": "Path 9797",
    d: "M161.757,118.446H6.325c-3.492,0-6.321-2.386-6.325-5.326v-31c0-2.94,2.833-5.322,6.325-5.326H161.757c3.492,0,6.322,2.386,6.326,5.326v31c0,2.94-2.834,5.322-6.326,5.326M6.325,77.841c-2.8,0-5.074,1.916-5.078,4.275v31c0,2.36,2.275,4.273,5.078,4.275H161.757c2.8,0,5.075-1.915,5.079-4.275v-31c0-2.36-2.275-4.273-5.078-4.275Z",
    transform: "translate(0 -76.791)",
    fill: "#96b3ea",
    opacity: 0.409
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9798",
    "data-name": "Path 9798",
    d: "M90.612,108.479a3.821,3.821,0,1,0,3.836,3.821,3.767,3.767,0,0,0-3.836-3.821m0,6.137a2.322,2.322,0,1,1,2.156-2.316,2.21,2.21,0,0,1-2.156,2.316m-8.366-6.137a3.821,3.821,0,1,0,3.832,3.821,3.766,3.766,0,0,0-3.832-3.821m0,6.137A2.322,2.322,0,1,1,84.4,112.3a2.21,2.21,0,0,1-2.157,2.316m-9.954-4.965v1.62h3.879a3.38,3.38,0,0,1-.883,2.038,3.97,3.97,0,0,1-3,1.187,4.314,4.314,0,0,1,0-8.628,4.134,4.134,0,0,1,2.924,1.159l1.141-1.141a5.656,5.656,0,0,0-4.068-1.635,5.935,5.935,0,1,0,0,11.87,5.425,5.425,0,0,0,4.139-1.666,5.356,5.356,0,0,0,1.4-3.793,5.273,5.273,0,0,0-.087-1.013ZM113,110.91a3.551,3.551,0,0,0-3.271-2.432,3.631,3.631,0,0,0-3.6,3.821,3.743,3.743,0,0,0,3.793,3.821,3.8,3.8,0,0,0,3.185-1.693l-1.3-.868a2.183,2.183,0,0,1-1.882,1.06,1.945,1.945,0,0,1-1.853-1.158l5.11-2.113Zm-5.211,1.274a2.1,2.1,0,0,1,2-2.229,1.478,1.478,0,0,1,1.419.81Zm-4.158,3.706h1.68V104.656h-1.68Zm-2.75-6.558h-.056a2.65,2.65,0,0,0-2.011-.854,3.825,3.825,0,0,0,0,7.643,2.609,2.609,0,0,0,2.011-.868h.056v.55c0,1.462-.782,2.244-2.038,2.244a2.113,2.113,0,0,1-1.925-1.361l-1.463.608a3.642,3.642,0,0,0,3.388,2.258c1.969,0,3.631-1.158,3.631-3.981v-6.862h-1.6Zm-1.925,5.283A2.323,2.323,0,1,1,101.1,112.3a2.324,2.324,0,0,1-2.144,2.316m21.906-9.959h-4.017v11.232h1.676v-4.256h2.342a3.494,3.494,0,1,0,0-6.977m.043,5.414h-2.385v-3.85h2.385a1.926,1.926,0,1,1,0,3.85m10.361-1.613a3.149,3.149,0,0,0-2.991,1.72l1.489.621a1.588,1.588,0,0,1,1.531-.823,1.613,1.613,0,0,1,1.763,1.445v.116a3.71,3.71,0,0,0-1.749-.434c-1.6,0-3.237.881-3.237,2.527a2.6,2.6,0,0,0,2.788,2.471A2.364,2.364,0,0,0,133,115h.056v.867h1.62v-4.306c0-1.994-1.489-3.107-3.41-3.107m-.2,6.156c-.55,0-1.315-.274-1.315-.954,0-.867.954-1.2,1.777-1.2a2.984,2.984,0,0,1,1.532.375,2.032,2.032,0,0,1-1.993,1.777m9.508-5.91-1.922,4.87H138.6L136.6,108.7H134.8l2.991,6.806-1.7,3.785h1.749l4.61-10.592Zm-15.1,7.186h1.676V104.656h-1.676Z",
    transform: "translate(-6.353 -85.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9799",
    "data-name": "Path 9799",
    d: "M16.64,88.922a1.794,1.794,0,0,0-.416,1.261v19.854a1.794,1.794,0,0,0,.416,1.261l.067.065,11.122-11.122V99.98L16.706,88.858Z",
    transform: "translate(15.774 -79.088)",
    fill: "#40bff2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57075",
    "data-name": "Group 57075",
    transform: "translate(24.992 17.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57074",
    "data-name": "Group 57074",
    transform: "translate(18.611 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 9.439,
    height: 7.679,
    transform: "translate(-0.001 -0.002)",
    fill: "#ffec03"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57077",
    "data-name": "Group 57077",
    transform: "translate(13.803 21.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57076",
    "data-name": "Group 57076",
    transform: "translate(18.611)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3469",
    "data-name": "Rectangle 3469",
    width: 18.852,
    height: 18.852,
    transform: "translate(-5.841 5.842) rotate(-45)",
    fill: "#ff7272"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57079",
    "data-name": "Group 57079",
    transform: "translate(13.803 9.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57078",
    "data-name": "Group 57078",
    transform: "translate(18.611 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3470",
    "data-name": "Rectangle 3470",
    width: 18.757,
    height: 18.757,
    transform: "translate(-5.773 5.776) rotate(-45)",
    fill: "#94f44e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57081",
    "data-name": "Group 57081",
    transform: "translate(41.634 9.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57088",
    "data-name": "Group 57088",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9803",
    "data-name": "Path 9803",
    d: "M70.776,89.183a1.919,1.919,0,0,0-1.273-.489,2.031,2.031,0,0,0,0,4.059,1.534,1.534,0,0,0,1.688-1.428h-1.5V90.7H72c0,1.857-.989,2.731-2.5,2.731a2.713,2.713,0,1,1,0-5.425,2.615,2.615,0,0,1,1.788.7Z",
    transform: "translate(-48.179 -88.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9804",
    "data-name": "Path 9804",
    d: "M81,88.119v.667H78.582v1.688h2.11v.67h-2.11v1.6h2.492v.667h-3.2V88.119Z",
    transform: "translate(-53.069 -88.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9805",
    "data-name": "Path 9805",
    d: "M88.65,88.119v.675h-1.6V93.4h-.722V88.794h-1.6v-.675Z",
    transform: "translate(-56.093 -88.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3471",
    "data-name": "Rectangle 3471",
    width: 0.713,
    height: 5.286,
    transform: "translate(35.266 0.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9806",
    "data-name": "Path 9806",
    d: "M103.483,88.119v.675h-1.6V93.4h-.722V88.794h-1.6v-.675Z",
    transform: "translate(-62.64 -88.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9807",
    "data-name": "Path 9807",
    d: "M113.5,88.009a2.713,2.713,0,1,1-2.669,2.717,2.682,2.682,0,0,1,2.669-2.717m0,4.734a2.022,2.022,0,1,0-1.957-2.017,1.971,1.971,0,0,0,1.957,2.017",
    transform: "translate(-67.614 -88.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9808",
    "data-name": "Path 9808",
    d: "M125.493,93.4l-2.408-3.981V93.4h-.713V88.119h.706l2.386,3.951V88.119h.714V93.4Z",
    transform: "translate(-72.71 -88.058)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStore);
export default __webpack_public_path__ + "static/media/google-store.4e6556bba5ba91114ffed0a9fde4886f.svg";
export { ForwardRef as ReactComponent };